import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import PageTemplate from '../../../components/template/PageTemplate';
import NoticeProductDetailContainer from '../../../containers/notice/NoticeProductDetailContainer';
import { noticeProductActions } from '../../../store/modules/notice/product';
import { NOTICE_PRODUCT_PAGE_NAME } from '../../../constants/service/app/noticeProductConstants';
import { LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';

const NoticeProductDetail = (props) => {
  const { getNoticeProductInfo } = props;
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      getNoticeProductInfo({
        productNoticeId: Number(id),
        pagination: LIST_PAGINATION_MODEL,
      });
    }
  }, [id, getNoticeProductInfo]);

  return (
    <PageTemplate pageName={NOTICE_PRODUCT_PAGE_NAME.DETAIL}>
      <NoticeProductDetailContainer productNoticeId={id} isEditable={false} />
    </PageTemplate>
  );
};

const mapDispatchToProps = {
  getNoticeProductInfo: noticeProductActions.getNoticeProductInfo,
};

export default connect(null, mapDispatchToProps)(NoticeProductDetail);
